<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div v-if="payment">
        <div><b>บัตรเครดิต/เดบิตปัจจุบันของคุณ</b></div>
        <div v-if="!payment.is_expired">
          <payment-small :payment="payment" class="section-checkout mt-3"/>
          <button class="btn btn-info btn-block mt-3"
                  :disabled="loading"
                  @click="submit()"
                  v-if="!paymentSuccess">{{ submitButton }}
          </button>
          <div class="text-center p-2" v-else>
            <i class="fas fa-check-circle -status-accepted"></i>
            {{ $t('message.success') }}
          </div>
        </div>
        <div v-else>
          <payment-small :payment="payment" class="section-checkout mt-3"/>
          <template v-if="addingNewCard">
            <hr>
            <payment-form ref="paymentForm" :paymentData="paymentData"/>
            <button class="btn btn-info btn-block mt-3"
                    :disabled="loading"
                    @click="addNewCard()"
                    v-if="!paymentSuccess">{{ submitButton }}
            </button>
            <div class="text-center p-2" v-else>
              <i class="fas fa-check-circle -status-accepted"></i>
              {{ $t('message.success') }}
            </div>
          </template>
          <template v-else>
            <button class="button button-block button-outline"
                    @click="displayCreditCardForm()"
                    v-if="!paymentSuccess">
              {{ $t('message.payment_method.add_new_card') }}
            </button>
            <div class="text-center p-2" v-else>
              <i class="fas fa-check-circle -status-accepted"></i>
              {{ $t('message.success') }}
            </div>
          </template>
        </div>
      </div>
      <div v-else>
        <payment-form ref="paymentForm" :paymentData="paymentData"/>
        <button class="btn btn-info btn-block mt-3"
                :disabled="loading"
                @click="addNewCard()"
                v-if="!paymentSuccess">{{ submitButton }}
        </button>
        <div class="text-center p-2" v-else>
          <i class="fas fa-check-circle -status-accepted"></i>
          {{ $t('message.success') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import PaymentForm from '../../payment/PaymentForm'
  import PaymentSmall from '../../payment/PaymentSmall'
  import axios from 'axios'

  export default {
    props: {
      message: Object
    },
    components: {
      PaymentForm,
      PaymentSmall
    },
    data () {
      return {
        addingNewCard: false,
        paymentData: {
          name: null,
          number: null,
          expirationDate: '',
          securityCode: null,
          savePayment: true,
          displaySavePayment: true,
          isDefault: false
        },
        omiseTokens: {
          secureToken: null,
          token: null
        },
        loading: false,
        paymentSuccess: false
      }
    },
    computed: {
      ...mapGetters({
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        globalState: 'globalVal/getState',
        payment: 'payment/getPayment',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['bookingData']),
      submitButton () {
        return this.loading ? 'กำลังดำเนินการ' : 'ยืนยันการชำระเงิน'
      }
    },
    watch: {
      'omiseTokens.token': function (newVal, oldVal) {
        if (this.omiseTokens.secureToken && this.omiseTokens.token) {
          const submitData = {
            user_id: this.user.id,
            token: this.omiseTokens.secureToken,
            return_uri: `${location.origin}/chat-booking?chat_booking_id=${this.bookingData.id}`,
            omise_account: 'hellobeneat'
          }
          this.checkOmiseSecure(submitData)
        }
      }
    },
    methods: {
      displayCreditCardForm () {
        this.addingNewCard = true
        this.$parent.$parent.scrollToBottom()
      },
      addNewCard () {
        if (this.$refs.paymentForm.paymentFormValidation()) {
          this.loading = true
          const cardNumber = this.paymentData.number.replace(/\s+/g, '')
          let arrExpiration = this.paymentData.expirationDate.split('/')
          const expirationMonth = arrExpiration[0]
          const expirationYear = 2000 + parseInt(arrExpiration[1])
          const card = {
            'name': this.paymentData.name,
            'number': cardNumber,
            'expiration_month': expirationMonth,
            'expiration_year': expirationYear,
            'security_code': this.paymentData.securityCode
          }
          // Perform omise process
          this.omiseTokens.secureToken = null
          this.omiseTokens.token = null
          // Get token from omise secure for otp
          window.Omise.setPublicKey(this.globalState.omisePublicKey)
          window.Omise.createToken('card', card, (statusCode, response) => {
            if (statusCode === 200 && response.object === 'token') {
              const omiseToken = response.id
              this.omiseTokens.secureToken = omiseToken
              // Get token from omise non-secure for adding omise customer id
              window.Omise.setPublicKey(this.globalState.omisePublicKey)
              window.Omise.createToken('card', card, (statusCode, response) => {
                if (statusCode === 200 && response.object === 'token') {
                  const omiseToken = response.id
                  this.omiseTokens.token = omiseToken
                  this.$store.commit('payment/SET_TMP_OMISE_TOKEN', omiseToken)
                } else {
                  this.loading = false
                  const alertText = 'Error: ' + response.message
                  this.$swal({text: alertText, type: 'error'})
                }
              })
            } else {
              this.loading = false
              const alertText = 'Error: ' + response.message
              this.$swal({text: alertText, type: 'error'})
            }
          })
        }
      },
      checkOmiseSecure (submitData) {
        const url = 'payments/' + this.user.id + '/check-omise-secure'
        axios.post(url, submitData)
          .then(res => {
            const response = res.data
            if (!response.error) {
              this.paymentSuccess = true
              this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', response.omise_charge_id)
              window.location = response.authorize_uri
            } else {
              this.loading = false
              this.$swal({text: 'Error payment:' + response.message, type: 'error'})
              this.omiseTokens.secureToken = null
              this.omiseTokens.token = null
            }
          })
          .catch(error => {
            console.log(error)
            this.$swal({text: error.message, type: 'error'})
          })
      },
      submit () {
        this.loading = true
        const url = `chat-bookings/${this.bookingData.id}/full-order-data`
        const params = {
          payment_method: 'credit_card',
          omise_customer_id: this.payment.omise_customer_id,
          total_price: this.bookingData.total_price,
          service_vat: this.bookingData.service_vat,
          discount_cost: this.bookingData.discount_cost,
          credit_discount_cost: this.bookingData.credit_discount_cost,
          is_credit: this.bookingData.is_credit
        }
        if (this.appliedPromoCode) {
          params.promo_code_id = this.appliedPromoCode.id
        }
        axios.post(url, params)
          .then(res => {
            const response = res.data
            if (!response.error) {
              const fullOrderData = response.full_order_data
              // inserted chat_booking_id to updated order_id or package_id in tb_chat_booking
              fullOrderData.chat_booking_id = this.bookingData.id
              if (fullOrderData.package_type_id === null) {
                this.addOrder(fullOrderData)
              } else {
                this.addPackage(fullOrderData)
              }
            } else {
              this.loading = false
            }
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            this.$swal({text: error.message, type: 'error'})
          })
      },
      addOrder (orderData) {
        const url = 'orders'
        axios.post(url, orderData)
          .then(res => {
            const response = res.data
            if (!response.error) {
              // Delete chat booking data when order is added
              this.deleteChatBooking()
            } else {
              this.loading = false
              this.$swal({text: response.message, type: 'error'})
            }
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            this.$swal({text: error.message, type: 'error'})
          })
      },
      addPackage (orderData) {
        const url = 'packages'
        axios.post(url, orderData)
          .then(res => {
            const response = res.data
            if (!response.error) {
              // Delete chat booking data when order is added
              this.deleteChatBooking()
            } else {
              this.$swal({text: response.message, type: 'error'})
            }
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            this.$swal({text: error.message, type: 'error'})
          })
      },
      deleteChatBooking () {
        const url = `chat-bookings/${this.bookingData.id}`
        axios.delete(url)
          .then(res => {
            this.paymentSuccess = true
            const response = res.data
            console.log('delete response', response)

            // Send auto reply message to user
            const message = {
              sender_type: 'user',
              type: 'text',
              label: 'success-credit-card',
              text: 'ยืนยันการชำระเงินด้วยบัตรเครดิต/เดบิต'
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            this.$swal({text: error.message, type: 'error'})
          })
      },
      sendMessage (item) {
        const itemType = item.type
        switch (itemType) {
          case 'message':
            const message = {
              sender_type: 'user',
              type: 'text',
              label: item.label,
              text: item.text,
              data: item.data
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
            break
          case 'uri':
            window.open(item.uri, '_blank')
            break
        }
      }
    },
    mounted () {
      if (this.user) {
        // Fetch payment data
        this.$store.dispatch('payment/LOAD_PAYMENT_DETAIL', this.user.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/CreditCardMessage.vue